import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
const StyledNavButton = styled.span`
  background: none;
  padding: 1em 1em;
  border-radius: 6px;
  border: none;
  font-family: "Titillium Web";
  font-size: 1.5em;
  color: #3f4441;
  text-transform: uppercase;
  font-weight: bold;
  z-index: 500;
  cursor: pointer;

  &:hover {
    background: #3f4441;
    color: white;
    transition: background-color 0.4s;
    & > a {
      color: white;
    }
  }
  @media (min-width: 750px) {
    & {
      padding: 0.5em 1em;
      font-size: 1.3rem;
      font-weight: bold;
    }
  }
  @media (min-width: 1200px) {
    & {
      font-size: 1rem;
    }
  }
`;

const NavButton = ({ url, label, fn }) => {
  return (
    <StyledNavButton onClick={fn}>
      <Link to={`${url}`}>{label}</Link>
    </StyledNavButton>
  );
};

export default NavButton;
